<typography *ngIf="!value" look="inputPlaceholder">{{ placeholder }}</typography>

<typography *ngIf="value?.start">
  {{ value.start | rdrDate: { withoutTimezones: true } }}
  <ng-container *ngIf="value?.end"
    >- {{ value.end | rdrDate: { withoutTimezones: true } }}</ng-container
  >
</typography>
